export const SENSITIVE_DATA_OMITTED = 'sensitive_data_omitted';

export const toPersonIdToSurveyResponseLookup = (surveyResponses) => {
  const surveyResponseLookup = (surveyResponses ?? []).reduce((acc, sr) => {
    // Remove when we everything is typed and we know this is not possible
    if (sr?.person?.id) {
      acc[sr.person.id] = sr;
    }
    return acc;
  }, {});
  return surveyResponseLookup;
};

type Identifiers = {
  platform_id?: string | null;
  external_id?: string | number | null;
  email?: string | null;
};

const MANAGER_IDENTIFIER_FIELDS = [
  'manager_platform_id',
  'manager_external_id',
  'manager_email',
];

export const managerIdentifiersChanged = (
  oldConfig: Record<string, any>,
  newConfig: Record<string, any>
): boolean =>
  MANAGER_IDENTIFIER_FIELDS.some(
    (field) => (oldConfig?.[field] || null) != (newConfig?.[field] || null)
  );

const additionalManagerKey = (identifiers: Identifiers): string =>
  [identifiers.platform_id, identifiers.external_id, identifiers.email]
    .map((value) => value ?? '')
    .join('|');

export const additionalManagersIdentifiersChanged = (
  oldConfig: Record<string, any>,
  newConfig: Record<string, any>
): boolean => {
  const oldKeys = (oldConfig?.additional_managers_identifiers ?? []).map(
    additionalManagerKey
  );
  const newKeys = (newConfig?.additional_managers_identifiers ?? []).map(
    additionalManagerKey
  );
  return (
    oldKeys.length !== newKeys.length ||
    oldKeys.some((key) => !newKeys.includes(key))
  );
};

// the participant named by identifiers, tried in the campaign sync's
// order: platform id, then external id, then email
export const findSurveyResponseByIdentifiers = (
  surveyResponses: Record<string, any>[],
  identifiers: Identifiers
): Record<string, any> | undefined => {
  const readers: [
    string | number | null | undefined,
    (sr: Record<string, any>) => any,
  ][] = [
    [identifiers.platform_id, (sr) => sr.configs?.platform_id],
    [
      identifiers.external_id,
      (sr) => sr.person?.external_id || sr.configs?.external_id,
    ],
    // email is not always present in person object
    // for example for terminated employees where HRIS wipes the email
    // so we use the email of the dataset configs.email as a fallback
    [identifiers.email, (sr) => sr.person?.email || sr.configs?.email],
  ];
  for (const [value, read] of readers) {
    if (!value) {
      continue;
    }
    const surveyResponse = surveyResponses.find((sr) => read(sr) == value);
    if (surveyResponse) {
      return surveyResponse;
    }
  }
  return undefined;
};
